import React from 'react';
// images
// import Logo from '../assets/jjlogo.svg';

const Header = () => {
  return (
    <header className='py-8'>
      <div className='container mx-auto'>
        <div className='flex justify-between items-center'>
          {/* logo */}
          <a href='#'>
            {/* <img src={Logo} alt='' /> */}
          </a>
          {/* button */}
          <a href="https://calendly.com/jamiljalal7794/30min?month=2025-08" target="_blank" rel="noopener noreferrer">
            <button className='btn btn-sm'>Work with me</button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
